import { render } from "./LayoutAdmin.vue?vue&type=template&id=e998d37e&scoped=true&ts=true"
import script from "./LayoutAdmin.vue?vue&type=script&lang=ts"
export * from "./LayoutAdmin.vue?vue&type=script&lang=ts"

import "./LayoutAdmin.vue?vue&type=style&index=0&id=e998d37e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e998d37e"]])

export default __exports__